import React from 'react';

const Navigation = ({ isFirstPage, isLastPage, onPrevious, onNext }) => {
    return (
        <div className={`ecx-survey-preview__nav${isFirstPage ? ' is-end' : ''}`}>
            {!isFirstPage ? (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill"
                    onClick={onPrevious}
                >
                    <i className="bi bi-chevron-left me-1" />
                    Previous
                </button>
            ) : (
                <span />
            )}

            {!isLastPage ? (
                <button type="button" className="btn btn-sm btn-primary rounded-pill" onClick={onNext}>
                    Next
                    <i className="bi bi-chevron-right ms-1" />
                </button>
            ) : (
                <button type="submit" className="btn btn-sm btn-primary rounded-pill">
                    <i className="bi bi-send-check me-1" />
                    Submit survey
                </button>
            )}
        </div>
    );
};

export default Navigation;
